import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import './Receipts.scss';

import commonConstant from '../../common/_commonConstant';
import { randomNumber } from '../../common/_commonFunction';
import {
  historyPayment,
  timeIn,
  validateToShowDash,
  dateDDMMYYYYFormat,
  getTimeHHMMSS,
  vehicleLicensePlate,
  buildingName,
  paymentRefNo,
  minutesToMillisec,
  validateMoney,
  calculateAmount,
  calculateVat,
  paymentTotalAmount,
  calculateOvernight,
  paymentTotalFeeAmount,
  overnightAmount,
  minutesToHr,
  buildingCompanyName,
  buildingTaxID,
  buildingPosID,
  buildingRefNo,
  vehicleProvince,
} from '../../helpers';
import { Loading } from '../../components';
import html2canvas from 'html2canvas';

// Interim solution: this building gets a Coupon header instead of a receipt
const COUPON_BUILDING_REF_NO = '1010';

class Receipts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeIndex': props.activeIndex ? props.activeIndex : 0,
      'items': null,
      'pages': null,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.getParkingStatus) {
      this.setState({ 'items': this.handleReceipts(), 'pages': this.handlePagination() });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { getParkingStatus } = this.props;

    if (nextProps.getParkingStatus && nextProps.getParkingStatus !== getParkingStatus) {
      return this.setState({
        'items': this.handleReceipts(nextProps.getParkingStatus),
        'pages': this.handlePagination(nextProps.getParkingStatus),
      });
    }
  }

  handlePagination = newGetParkingStatus => {
    try {
      const { activeIndex } = this.state;
      const { getParkingStatus } = this.props;
      const data = newGetParkingStatus ? newGetParkingStatus : getParkingStatus;

      return data.previousPayment.map((ele, index) => (
        <div
          id={`pagination-item-${index}`}
          className={`pagination-item page-${index}${(activeIndex ? index === activeIndex : index === 0) ? ' active' : ''}`}
          key={randomNumber()}
          onClick={() => this.handleSetPage(index)}
        >
          {index + 1}
        </div>
      ));
    } catch (error) {
      return null;
    }
  }

  handleCheckSetPage = index => {
    const { getParkingStatus } = this.props;

    if (index < 0 || index === getParkingStatus.previousPayment.length) {
      return null;
    }
    return this.handleSetPage(index);
  }

  handleSetPage = activeIndex => {
    document.querySelector('.pagination-item.active').className = `pagination-item page-${this.state.activeIndex}`;
    document.querySelector(`.pagination-item.page-${activeIndex}`).className += ' active';
    return this.setState({ activeIndex });
  }

  handleReceipts = newGetParkingStatus => {
    try {
      const { getParkingStatus, getBuildingByRefNo } = this.props;
      const data = newGetParkingStatus ? newGetParkingStatus : getParkingStatus;

      if (!historyPayment(data)) {
        return null;
      }

      // Backend requires buildingTaxID, buildings without real values send '0'
      const taxIDValue = buildingTaxID(getBuildingByRefNo);
      const taxID = taxIDValue && Number(taxIDValue) !== 0 ? taxIDValue : null;

      // Backend requires buildingPosID, buildings without real values send '0'
      const posIDValue = buildingPosID(getBuildingByRefNo);
      const posID = posIDValue && Number(posIDValue) !== 0 ? posIDValue : null;

      const isCouponBuilding = buildingRefNo(getBuildingByRefNo) === COUPON_BUILDING_REF_NO;

      let defaultFreeParkingTime = 0;
      let sumParkingTime = 0;
      const parkingTimeIn = timeIn(data) ? timeIn(data) : null;
      return data.previousPayment.reverse().map((ele, index) => {
        const startTime = parkingTimeIn ? sumParkingTime ? (parkingTimeIn + minutesToMillisec(sumParkingTime)) : parkingTimeIn : null;
        sumParkingTime += ele.paymentTotalBuildingFreeParkingMinutes + ele.paymentTotalParkingFeeMinutes + ele.paymentTotalRedemptionMinutes - (ele.paymentTotalRedemptionMinutes === 0 ? 0 : defaultFreeParkingTime);
        defaultFreeParkingTime += ele.paymentTotalBuildingFreeParkingMinutes;
        const hasVat = ele.paymentVatRatePercentage !== 0 && ele.paymentVatRatePercentage !== 100;

        return (
          <div className="box" key={randomNumber()}>
            <div id="box-receipt" className="box-recripts">
              <div className="building text" id="building-name">
                {buildingName(getBuildingByRefNo)}
              </div>
              <div className="address text" id="payment-company-name">
                {buildingCompanyName(getBuildingByRefNo)}
              </div>
              {
                taxID ?
                  <div className="tax text">TAX ID : <span className="payment-tax-id">{taxID}</span></div> : null
              }
              <hr className="hr" />
              <div className="title">{isCouponBuilding ? 'Parking Coupon' : 'Receipt/ Tax Invoice (ABB)'}</div>
              {
                posID ?
                  <div className="detail-row">
                    <div className="label">POS ID</div>
                    <div className="value" id={`payment-pos-id-${index}`}>
                      {posID}
                    </div>
                  </div> : null
              }
              <div className="detail-row">
                <div className="label">Ref ID</div>
                <div className="value" id={`payment-ref-number-${index}`}>
                  {validateToShowDash(paymentRefNo(ele))}
                </div>
              </div>
              <div className="detail-row">
                <div className="label">License no.</div>
                <div className="value" id={`payment-license-plate-${index}`}>{validateToShowDash(vehicleLicensePlate(data))}</div>
              </div>
              <div className="detail-row">
                <div className="label">Province</div>
                <div className="value" id={`payment-vehicle-province-${index}`}>{validateToShowDash(vehicleProvince(data))}</div>
              </div>
              <div className="detail-row">
                <div className="label">เริ่มตั้งแต่เวลา</div>
                <div className="value" id={`payment-start-time-${index}`}>
                  {validateToShowDash(dateDDMMYYYYFormat(startTime))} {validateToShowDash(getTimeHHMMSS(startTime))}
                </div>
              </div>
              <div className="detail-row">
                <div className="label">สิทธิ์จอดรถฟรีรวม</div>
                <div className="value" id={`payment-total-free-minutes-${index}`}>
                  {
                    ele.paymentTotalRedemptionMinutes ?
                      minutesToHr((ele.paymentTotalRedemptionMinutes - defaultFreeParkingTime))
                      : minutesToHr(ele.paymentTotalBuildingFreeParkingMinutes)
                  } ชม.
                </div>
              </div>
              <div className="detail-row">
                <div className="label">จอดได้ถึง</div>
                <div className="value" id={`payment-end-time-${index}`}>
                  <span>{validateToShowDash(dateDDMMYYYYFormat(new Date(parkingTimeIn).setMinutes(new Date(parkingTimeIn).getMinutes() + sumParkingTime)))}</span>
                  <span> {validateToShowDash(getTimeHHMMSS(new Date(parkingTimeIn).setMinutes(new Date(parkingTimeIn).getMinutes() + sumParkingTime)))}</span>
                </div>
              </div>
              <hr className="hr" />
              <div className="detail-row btw">
                <div className="label">Parking fee amount (Baht)</div>
                <div className="value" id={`payment-parking-fee-${index}`}>
                  {validateMoney(isCouponBuilding ? paymentTotalFeeAmount(ele) : calculateAmount(ele))}
                </div>
              </div>
              <div className="detail-row btw">
                <div className="label">Overnight charge amount (Baht)</div>
                <div className="value" id={`payment-overnight-${index}`}>
                  {validateMoney(isCouponBuilding ? overnightAmount(ele) : calculateOvernight(ele))}
                </div>
              </div>
              {
                taxID && hasVat && !isCouponBuilding ?
                  <div className="detail-row btw">
                    <div className="label">{`Vat ${ele.paymentVatRatePercentage - 100}% (Baht)`}</div>
                    <div className="value" id={`payment-vat-${index}`}>
                      {validateMoney(calculateVat(ele))}
                    </div>
                  </div> : null
              }
              <hr className="hr" />
              <div className="detail-row btw">
                <div className="label">Total amount (Baht)</div>
                <div className="value" id={`payment-total-fee-${index}`}>
                  {validateMoney(paymentTotalAmount(ele))}
                </div>
              </div>
              {
                taxID && hasVat && !isCouponBuilding ? <div className="vat">(ITEM VAT INCLUDED)</div> : null
              }
              <div className="box-logo">
                <img className="logo" src={commonConstant.ezyParkLogo} alt="" />
                <span className="text-logo">
                  <div className="title">EZY PARKING</div>
                  <div className="description">SMART PAYMENT SOLUTION</div>
                </span>
              </div>
            </div>
          </div>
        );
      });
    } catch (error) {
      return null;
    }
  }

  handlePrint = async () => {
    const reciptElement = document.getElementById('box-receipt');
    if (!reciptElement) {return;}

    const canvas = await html2canvas(reciptElement, {
      'scale': 10,
      'width': reciptElement.offsetWidth,
      'height': reciptElement.offsetHeight,
    });

    const dataUrl = canvas.toDataURL('image/png');

    const html = `
      <html>
        <head>
          <title>Receipt</title>
          <style>
            @page { size: 100% auto; margin: 0; }
            html, body { width: 100%; margin: 0; padding: 0; }
            .wrap { width: 100%; margin: 0 auto; }
            img {
              width: 100%; height: auto; display: block;
              -webkit-print-color-adjust: exact; print-color-adjust: exact;
              image-rendering: -webkit-optimize-contrast;
            }
            .tail { height: 4mm; } /* prevent cutter clipping */
          </style>
        </head>
        <body>
          <div class="wrap"><img src="${dataUrl}" alt="receipt"></div>
          <script>
            window.onload = () => {
     
            };
          </script>
        </body>
      </html>
    `;

    const blob = new Blob([html], { 'type': 'text/html' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  render() {
    const { getParkingStatus } = this.props;
    const { activeIndex, items, pages } = this.state;

    if (!getParkingStatus || !getParkingStatus.previousPayment) {
      return <Loading />;
    }

    return (
      <div className="Receipts">
        {items ? items[activeIndex] : null}
        <div className="print-box-container">
          {
            historyPayment(getParkingStatus) && getParkingStatus.previousPayment.length > 1 ?
              <>
                <div className="box-pagination">
                  <span
                    id={`payment-prev-${activeIndex}`}
                    className={`box-arrow left fas fa-chevron-left${activeIndex > 0 ? ' active' : ''}`}
                    onClick={() => this.handleCheckSetPage(activeIndex - 1)}
                  />
                  {pages}
                  <span
                    id={`payment-next-${activeIndex}`}
                    className={`box-arrow right fas fa-chevron-right${activeIndex === (getParkingStatus.previousPayment.length - 1) ? '' : ' active'}`}
                    onClick={() => this.handleCheckSetPage(activeIndex + 1)}
                  />
                </div>
              </>
              : null
          }
          <div className="print-button-container">
            <Button onClick={() => this.handlePrint()} className="print-button">
              <span className="icon icon-print" id="btn-print-icon" />
              <span>พิมพ์ใบเสร็จ</span>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

Receipts.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'language': PropTypes.string,
  'showStatus': PropTypes.func.isRequired,
  'activeIndex': PropTypes.any,
  'getParkingStatus': PropTypes.shape({
    'previousPayment': PropTypes.array,
  }),
  'getBuildingByRefNo': PropTypes.shape({}),
};

const mapStateToProps = ({ getParkingStatus, getBuildingByRefNo }) => ({
  'getParkingStatus': getParkingStatus.data,
  'getBuildingByRefNo': getBuildingByRefNo.data,
});

export default connect(mapStateToProps)(Receipts);
